import styled from 'styled-components';

const StyledTableButtonDiv = styled.div`
    height: 0;
    display: flex;
    align-items: center;
`;

export default StyledTableButtonDiv;
